/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 22:56:12
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import { createNamespace } from 'src/util/bem';
import { EnumCompareTaskConfirmStatus, EnumCompareTaskDealStatus } from 'src/enums/enumCompareTaskStatus';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import CompareTaskConfirmApi from './api/compareTaskConfirmApi';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';

export namespace ConfirmTaskVOI {
    export interface PropsI {
        operate: string;
        id: number;
        device_id: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        affirm_cause: string;
        affirm_condition: Integer;
        device_name: string;
        dispose_condition: Integer;
        dispose_explain: string;
        inform_number: string;
        initiator: string;
        operational_site: string;
        operational_content: string;
        operational_equipment: string[];
        sponsor_datetime: string;
        task_number: string;
        user_id: Integer;
    }

    export interface OperateFormDataI {
        affirm_cause: string;
        affirm_condition: Integer;
        user_id: Integer;
        dispose_explain: string;
    }
}

@Component
class ConfirmTaskModal extends Vue.Component<ConfirmTaskVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: Number,
    })
    device_id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: ConfirmTaskVOI.FormDataI = {
        affirm_cause: '',
        affirm_condition: null,
        device_name: '',
        dispose_condition: null,
        dispose_explain: '',
        inform_number: '',
        initiator: '',
        operational_site: '',
        operational_content: '',
        operational_equipment: [],
        sponsor_datetime: '',
        task_number: '',
        user_id: null,
    };

    operateForm: ConfirmTaskVOI.OperateFormDataI = {
        user_id: null,
        affirm_cause: '',
        affirm_condition: null,
        dispose_explain: '',
    };

    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        if (this.operateForm.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId() && !this.operateForm.affirm_cause) {
            return Toast.error('请填写原因');
        }
        let res;
        this.loading = true;
        switch (this.operate) {
            case EnumOperates.Confirm.getName():
                res = await CompareTaskConfirmApi.batchConfirm({
                    affirm_cause: this.operateForm.affirm_cause,
                    affirm_condition: this.operateForm.affirm_condition,
                    ids: [{ id: this.id, device_id: this.device_id }],
                });
                break;
            case EnumOperates.Distribute.getName():
                res = await CompareTaskConfirmApi.distribute({
                    id: this.id,
                    device_id: this.device_id,
                    user_id: this.operateForm.user_id,
                });
                break;
            case EnumOperates.Deal.getName():
                res = await CompareTaskConfirmApi.dispose({
                    id: this.id,
                    device_id: this.device_id,
                    dispose_explain: this.operateForm.dispose_explain,
                });
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }

    async mounted() {
        let { code, data } = await CompareTaskConfirmApi.searchDetail({ id: this.id, device_id: this.device_id });
        if (code === 0) {
            this.formData = {
                ...data,
                user_id: null,
            };
        }
    }

    render(h) {
        return (
            <Modal
                title={'对比任务' + this.operate}
                width="1000"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={this.operate === EnumOperates.Detail.getName()}
            >
                <i-form ref="formValidate" labelWidth={100} class={createNamespace('detail-form')} model={this.operateForm}>
                    <form-item label="通知单号：" style="display: inline-block;width:30%" labelWidth={80}>
                        {this.formData.inform_number}
                    </form-item>
                    <form-item label="任务单号：" style="display: inline-block;width:30%" labelWidth={80}>
                        {this.formData.task_number}
                    </form-item>
                    <form-item label="发起人" style="display: inline-block;width:20%" labelWidth={80}>
                        {this.formData.initiator}
                    </form-item>
                    <form-item label="发起时间" style="display: inline-block;width:20%" labelWidth={80}>
                        {this.formData.sponsor_datetime}
                    </form-item>
                    <form-item label="对比站点：" style="display: inline-block;width:90%">
                        {this.formData.device_name}
                    </form-item>
                    <form-item label="对比设备：" style="display: inline-block;width:90%">
                        {(this.formData.operational_equipment || []).join('、')}
                    </form-item>
                    <form-item label="对比内容：" style="display: inline-block;width:90%">
                        {this.formData.operational_content}
                    </form-item>
                    <div class={createNamespace('mt15')}>
                        <form-item label="确认情况：" style="display: inline-block;width:30%" v-if={this.formData.affirm_condition}>
                            {EnumCompareTaskConfirmStatus.findId(this.formData.affirm_condition).getName()}
                        </form-item>
                        <form-item
                            label="原因说明："
                            style="display: inline-block;width:60%"
                            v-if={this.formData.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId()}
                        >
                            {this.formData.affirm_cause}
                        </form-item>
                    </div>
                    <div v-if={this.formData.dispose_condition}>
                        <form-item label="处理情况：" style="display: inline-block;width:30%" >
                            {EnumCompareTaskDealStatus.findId(this.formData.dispose_condition).getName()}
                        </form-item>
                        <form-item label="处理原因：" style="display: inline-block;width:60%">
                            {this.formData.dispose_explain}
                        </form-item>
                    </div>
                    <form-item
                        label="确认："
                        style="width:45%;margin-top:15px;"
                        v-if={this.operate === EnumOperates.Confirm.getName()}
                        required
                        type="number"
                        prop="affirm_condition"
                    >
                        <CommonSelect dataSource={EnumCompareTaskConfirmStatus.getList()} v-model={this.operateForm.affirm_condition} />
                    </form-item>
                    <form-item
                        label="原因："
                        style="width:45%"
                        v-if={
                            this.operate === EnumOperates.Confirm.getName() &&
                            this.operateForm.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId()
                        }
                    >
                        <Input placeholder="请输入" v-model={this.operateForm.affirm_cause} type="textarea" />
                    </form-item>
                    <form-item
                        v-if={this.operate === EnumOperates.Distribute.getName()}
                        label="处理人"
                        prop="user_id"
                        type="number"
                        style="width:45%;margin-top:15px;"
                    >
                        <EntitySelect type={EnumEntity.User.getId()} v-model={this.operateForm.user_id} />
                    </form-item>
                    <form-item
                        label="处理说明："
                        style="width:45%"
                        prop="dispose_explain"
                        v-if={this.operate === EnumOperates.Deal.getName()}
                    >
                        <Input placeholder="请输入" v-model={this.operateForm.dispose_explain} type="textarea" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertConfirmTaskModal(operate: string, id: number, device_id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<ConfirmTaskVOI.PropsI>(ConfirmTaskModal)({
            id,
            operate,
            device_id,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
